import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
// 删除 Dashboard 的导入
import QuestionBank from '@/views/QuestionBank.vue';
import ExportedCourses from '@/views/ExportedCourses.vue';
import Profile from '@/views/Profile.vue';
import TokenManagement from '../views/TokenManagement.vue'
import KeyManagement from '../views/KeyManagement.vue';
import QueryStats from '../views/QueryStats.vue';

const SITE_NAME = '知弈题库';
const SITE_URL = 'https://anqingyou.top';
const DEFAULT_TITLE = `${SITE_NAME} - OCS网课助手最佳题库`;
const DEFAULT_DESCRIPTION = '知弈题库提供在线题库查询、题目搜索、题库配置与账号服务，支持高效搜题与学习辅助。';

function updateMetaTag(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function updateCanonical(path) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', `${SITE_URL}${path}`);
}

const routes = [
  {
    path: '/',
    redirect: '/profile' // 将默认路由改为题库搜索
  },
  // 删除 dashboard 路由
  {
    path: '/question-bank',
    name: 'QuestionBank',
    component: QuestionBank,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 题库搜索`,
      description: '知弈题库题库搜索页面，支持在线题目查询与学习辅助。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/exported-courses',
    name: 'ExportedCourses',
    component: ExportedCourses,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 浏览课程`,
      description: '知弈题库浏览课程列表与题目查看页面。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/exported-courses/:courseId',
    name: 'ExportedCourseDetail',
    component: ExportedCourses,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 课程题目`,
      description: '知弈题库课程题目详情页面。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 个人中心`,
      description: '知弈题库个人中心，查看账号信息、题库配置与学习服务。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/token-management',
    name: 'TokenManagement',
    component: TokenManagement,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - Token 管理`,
      description: '知弈题库 Token 管理页面。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/key-management',
    name: 'KeyManagement',
    component: KeyManagement,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 密钥管理`,
      description: '知弈题库密钥管理页面。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/query-stats',
    name: 'QueryStats',
    component: QueryStats,
    meta: {
      requiresAuth: true,
      title: `${SITE_NAME} - 查询统计`,
      description: '知弈题库查询统计页面。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: `${SITE_NAME} - 登录`,
      description: '登录知弈题库，使用题库搜索、题目查询与学习辅助功能。',
      robots: 'index,follow'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: `${SITE_NAME} - 注册`,
      description: '注册知弈题库账号，体验OCS网课助手最佳题库',
      robots: 'index,follow'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      title: `${SITE_NAME} - 找回密码`,
      description: '知弈题库账号找回密码页面。',
      robots: 'noindex,nofollow'
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守卫，检查用户是否已登录
router.beforeEach((to, from, next) => {
  const userStr = localStorage.getItem('user');
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录的路由
    if (!userStr) {
      next({ name: 'Login' });
      return;
    }
    
    next();
  } else {
    // 不需要登录的路由
    next();
  }
});

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  updateMetaTag('name', 'description', to.meta.description || DEFAULT_DESCRIPTION);
  updateMetaTag('name', 'robots', to.meta.robots || 'index,follow,max-image-preview:large');
  updateMetaTag('property', 'og:title', to.meta.title || DEFAULT_TITLE);
  updateMetaTag('property', 'og:description', to.meta.description || DEFAULT_DESCRIPTION);
  updateMetaTag('property', 'og:url', `${SITE_URL}${to.path}`);
  updateCanonical(to.path);
});

export default router;
